export default __webpack_public_path__ + "static/media/level_4.0ea64349.png";